import Appointment from "@/core/stores/appointment.js";
import Config from "@/core/stores/configs.js";
import General from "@/core/stores/general.js";
import loading from "@/core/stores/loading";
import Path from "@/core/stores/path.js";
import Patient from "@/core/stores/patient.js";
import User from "@/core/stores/user.js";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Appointment,
    Config,
    General,
    Patient,
    Path,
    User,
    loading
  }
});
